const ProgressBar = ({ progress, tenantColor }) => {
  return (
    <section>
      <div className="flex justify-between items-center">
        <span className="text-secundary-grey text-xs">Progress</span>

        <span className="text-secundary-grey text-sm">{progress || 0}%</span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2">
        <div
          className="h-2 rounded-full transition-all duration-300 ease-out"
          style={{ width: `${progress}%`, backgroundColor: tenantColor }}
        />
      </div>
    </section>
  );
};

export default ProgressBar;
